/* eslint-disable */
import React, { Component } from 'react';
import { Modal, Button, Checkbox, Tooltip, Popover, message  } from 'antd';
import request from 'axios';
import PDF from './PDF';
import './index.less';
let Gantanha=`https://img-hxy021.didistatic.com/static/ehr_static/imgs/perm/gantanhao.png`
class Authorization extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      read: false,
      warningColor: false,
      headerBorder: true,
      visibles: true,
      time: 10,
      fileData: {},
      popoverVisible: {
        0: false,
        1: false,
        2: false,
        3: false,
      },
      button: {
        authorized: [
          {
            text: '不适用',
            code: 2,
          },
          {
            text: '拒绝',
            code: 1,
          },
          {
            text: '同意',
            code: 0,
            type: 'primary',
          },
        ],
        revocation: [
          {
            text: '撤销授权',
            code: 3,
          },
        ],
      },
    };
  }

  async componentDidMount() {
        // 判断是否有数据传入
    if (this.props.fileData) {
      this.componentSetData('fileData', { ...this.props.fileData });
    } else {
      let data = await request({
        method: 'get',
        headers: {
         ...this.props.headers
        },
        url: this.props.getUserData&&this.props.getUserData.url,
        params: this.props.getUserData&&{
          ...this.props.getUserData.params
        },
      });
      data = data.data.data;
      if (!data) {
        message.error('未获取到数据');
        return;
      }
      // data.buttonCode='0000010'
      this.componentSetData('fileData', data);
    }
  }

    // PDF加载成功
  onLoadSuccess = () => {
    setTimeout(() => {
      const targetNode = document.querySelector('.react-pdf__Document');
      const modalBody = document.querySelector('.ant-modal-body');
      this.countdownClock(10);
      console.log(targetNode,modalBody)
      if(!(targetNode&&modalBody)){
        return 
      } 
      if (targetNode.offsetHeight <= modalBody.offsetHeight) {
        this.setState({
          headerBorder: true,
        });
      } else {
        this.setState({
          headerBorder: false,
        });
      }
    }, 0);
  }

     // 获取按钮
  getButton = () => {
    const { time, popoverVisible, button, read,fileData } = this.state;

    let data = [];
    let buttonType = '';
             // 根据状态返回按钮
    if ((fileData.signType === null && fileData.signFileUrl) || fileData.signType === 3) {                                        // 待授权
                // 添加按钮权限
      button.authorized = button.authorized.map((v, index) => {
        button.authorized[index].isShow = fileData.buttonCode[v.code];
        return v;
      });
      data = button.authorized;
      buttonType = 'authorized';
    } else if (fileData.signType === 0) {                                                                              // 撤销授权
                // 添加按钮权限
      button.revocation[0].isShow = fileData.buttonCode[button.revocation[0].code];
      button.revocation = button.revocation;
      data = button.revocation;
      buttonType = 'revocation';
    } else {
      data = [];
    }
    return data.map((v, index) => {
      if (v.isShow === '1') {
        const disabled = v.code === 0 ? time > 0 : false;
        const text = v.code === 0 ? `同意${time > 0 ? `(${time})` : ''}` : v.text;
        return (<Popover
          className="AuthorizationPopover"
          key={v.text}
          placement={index === data.length - 1 ? 'topRight' : 'top'}
          content={this.getPopoverContent(v, index, buttonType)}
          trigger="click"
          visible={popoverVisible[v.code]}
          onVisibleChange={(visible) => {
            if (v.code === 0 && !read) {
              this.setState({
                warningColor: true,
              });
              return;
            }
            popoverVisible[v.code] = visible;
            this.setState({
              popoverVisible: { ...this.state.popoverVisible },
            });
          }}
        >
          <Button {...v} disabled={disabled}>{text}</Button>
        </Popover>);
      }
      return '';
    });
  }

    // 按钮弹框
  getPopoverContent = (data, index, buttonType) => {
    const {  popoverVisible,fileData } = this.state;

    let text = '';
    if (fileData.warnCopywriting.includes('{')) {
        fileData.warnCopywriting = JSON.parse(fileData.warnCopywriting);
      }
    switch (data.code) {
      case 1:
        text = fileData.warnCopywriting.reject || fileData.warnCopywriting;
        break;
      case 2:
        text = fileData.warnCopywriting.notAvailable || fileData.notAvailable;
        break;
      case 3:
        text = fileData.warnCopywriting.revoked || fileData.revoked;
        break;
      default:
        break;
    }
    return (<div className="AuthorizationPopoverOfficial">
      <div className="officialTitle">
        <img alt="icon" src={Gantanha} />
        <span>确定{data.text}吗？</span></div>
      <div className="officialContent">{text}</div>
      <div className="officialButton">
        <Button onClick={() => {
          popoverVisible[data.code] = false;
          this.setState({
            popoverVisible: { ...this.state.popoverVisible },
          });
        }}
        >取消</Button>
        <Button onClick={() => this.submit(data.code, index, buttonType)} loading={data.loading} type="primary" >确定</Button>
      </div>
    </div>);
  }
  getCheck = () => {
    const { read, time,fileData } = this.state;

    if ((fileData.signType !== null && fileData.signType !== 3)||fileData.buttonCode[0]!=='1') {
      return '';
    } else if (time > 0) {
      return (<Tooltip placement="topLeft" title={`请耐心等待${time}秒`}>
        <Checkbox checked={read} disabled={time > 0}>本人已认真阅读并充分理解此合同/协议</Checkbox>
      </Tooltip>);
    }
    return (<Checkbox
      onChange={() => {
        this.setState({
          read: !this.state.read,
          warningColor: false,
        });
      }}
      checked={read}
      disabled={time > 0}
    >本人已认真阅读并充分理解此合同/协议</Checkbox>);
  }
  componentSetData = (name, data) => {
    this.setState({
      [name]: data,
    });
  }

   // 倒计时
  countdownClock = (newTime) => {
    
    if (newTime === 0||this.props.visible) {
      return;
    }
    const Time = newTime - 1;

    setTimeout(() => {
      this.setState({
        time: Time,
      });
      this.countdownClock(Time);
    }, 1000);
  }
  // 提交数据
  submit = (type, index, buttonType) => {
    const { read, popoverVisible, button,fileData } = this.state;

    if (type === 0 && !read) {
      this.setState({
        warningColor: true,
      });
      return;
    }
    const list = {
      sceneCode: this.props.sceneCode || fileData.sceneCode,
      templateCode: this.props.templateCode || fileData.templateCode,
      signType: type,
    };
    button[buttonType][index].loading = true;
    this.setState({
      button: { ...this.state.button },
    }, async () => {
      try {
        const data = await request({
          method: 'post',
          url: this.props.submitDataUrl,
          headers: {
            ...this.props.headers
          },
          data: list,
        });
        if (data.data.meta.code === 0) {
          let text = '';
          switch (type) {
            case 0:
              text = '授权成功';
              break;
            case 1:
              text = '拒绝成功';
              break;
            case 2:
              text = '不适用成功';
              break;
            case 3:
              text = '撤销成功';
              break;
            default:
              break;

          }
          if (data.data.data) {
            popoverVisible[type] = false;
            button[buttonType][index].loading = false;
            this.setState({
              popoverVisible: { ...this.state.popoverVisible },
              button: { ...this.state.button },
            });
            message.success(text);
            setTimeout(() => {
              (this.props.submitSucceed || this.submitSucceed)();
            }, 2000);
          } else {
            message.success('操作失败');
          }
        }
      } catch (err) {
        popoverVisible[type] = false;
        button[buttonType][index].loading = false;
        this.setState({
          popoverVisible: { ...this.state.popoverVisible },
          button: { ...this.state.button },
        });
        message.success('操作失败');
      }
    });
  }
  handleCancel = () => {
    this.props.handleCancel && this.props.handleCancel();
    this.setState({
      isLoading: true,
      read: false,
      warningColor: false,
      headerBorder: true,
      visibles: true,
      time: 10,
      fileData: {},
      popoverVisible: {
        0: false,
        1: false,
        2: false,
        3: false,
      },
    });
  }
  copyUrl = () => {
    var Url=this.state.fileData.signFileUrl;
    if(navigator.clipboard&&navigator.clipboard.writeText){
      navigator.clipboard.writeText(Url)
    }else{
      var oInput = document.createElement('input');
      oInput.value = Url+'#toolbar=0';
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = 'oInput';
      oInput.style.display='none';
    }
    message.success('链接复制成功！（分享链接1小时之内有效）')

  }

  render() {
    const { warningColor, headerBorder,fileData  } = this.state;
    return (
     <Modal
        title={<div style={{ height: '48px', padding: '0' }} />}
        visible={this.props.visible}
        width={800}
        closable={this.props.isClose&&fileData.buttonCode&&fileData.buttonCode[6] === '1'?true:false}
        onCancel={this.props.isClose&&fileData.buttonCode&&fileData.buttonCode[6] === '1'?this.handleCancel:false}
        className={`AuthorizationModal ${headerBorder ? 'headerBorder' : ''}`}
        footer={
          <div className="AuthorizationModalFooter">
            <div className={`${warningColor ? 'warningColor' : ''} Checkbox`}>
              {
                         this.getCheck()
                    }
            </div>
            <div className="Button">
              {/* {
                    fileData.buttonCode && fileData.buttonCode[4] === '1' ? <div className="download">
                      <Xiazai type={'icon-PCduan_xiazai'} style={{ width: '16px', height: '16px', marginRight: '4px' }} />
                        下载
                    </div> : ''
                } */}
                {
                  this.props.share &&fileData.buttonCode&&fileData.buttonCode[7] === '1' && <Button onClick={this.copyUrl} >分享给候选人</Button>
                }
                {
                  this.props.know && fileData.buttonCode&&fileData.buttonCode[5] === '1' && <Button onClick={this.handleCancel} >知道了</Button>
                }
                

              {
                        this.getButton()
                    }
            </div>

          </div>
        }
      >
        {
            fileData.signFileUrl && <PDF onLoadSuccess={this.onLoadSuccess} url={fileData.signFileUrl} width={752} />
        }
      </Modal>
    );
  }
}

export default Authorization;
